import { Field, FieldLabel, Input } from '@monksflow/monks-ui';
import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

export interface BooleanConfigFieldsProps {
  config: Record<string, unknown>;
  onChange: (patch: Record<string, unknown>) => void;
  disabled: boolean;
}

export function BooleanConfigFields(props: BooleanConfigFieldsProps) {
  const { t } = useTranslation('knowledge');
  const trueLabel = typeof props.config.trueLabel === 'string' ? props.config.trueLabel : '';
  const falseLabel = typeof props.config.falseLabel === 'string' ? props.config.falseLabel : '';

  return (
    <>
      <Field>
        <FieldLabel htmlFor="brief-section-config-true-label">
          {t('knowledgeHub.briefSectionConfigFields.trueLabel')}
        </FieldLabel>
        <Input
          id="brief-section-config-true-label"
          disabled={props.disabled}
          value={trueLabel}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            props.onChange({ trueLabel: event.target.value })
          }
        />
      </Field>
      <Field>
        <FieldLabel htmlFor="brief-section-config-false-label">
          {t('knowledgeHub.briefSectionConfigFields.falseLabel')}
        </FieldLabel>
        <Input
          id="brief-section-config-false-label"
          disabled={props.disabled}
          value={falseLabel}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            props.onChange({ falseLabel: event.target.value })
          }
        />
      </Field>
    </>
  );
}
